
import localForage from 'localforage';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { Clipboard } from '@capacitor/clipboard';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import OneSignal from 'onesignal-cordova-plugin';

export default {

  toggleView (view) {
    const query = !!view ? _.isObject(view) ? view : { view } : null; //_.omit(this.$route.query, 'view');
    this.$router.push({ query });
  },

  toggleHelp (b, context, section, item) {
    // this.help.toggle = b; 
    if (b) {
      this.toggleView({ view: 'help', context, section, item });
    }else{
      this.toggleView();
    }
  },

  toggleTicket (id) {
    this.toggleView({ view: 'help', ticket: id });
  },

  toggleEvent (id) {
    this.toggleView({ view: 'help', section: 'events', event: id });
  },

  format (fields, dictionary, outwards=false) {
    return _.mapValues(_.mapKeys(fields, (field, f) => {
      return outwards ? _.isObject(dictionary[f]) ? dictionary[f].key : dictionary[f] : _.findKey(dictionary, d => _.isObject(d)&&d.key==f ? d.key : d==f);
    }), (field, f) => {
      return _.isArray(field) ? _.map(field, item => {
        return !_.isObject(item) ? item : _.mapValues(_.mapKeys(item, (subfield, s) => {
          return outwards ? dictionary[f][s] : _.findKey(dictionary[f], d => d==s);
        }), (subfield, s) => {
          return s.indexOf(outwards ? 'dt_' : 'At')>=0&&subfield!=null ? this.formatDate(subfield, outwards) : subfield;
        });
      }) : !_.isObject(field) ? f.indexOf(outwards ? 'dt_' : 'At')>=0&&field!=null ? this.formatDate(field, outwards) : field : _.mapKeys(field, (subfield, s) => {
        return outwards ? dictionary[f][s] : _.findKey(dictionary[f], d => d==s);
      });
    });
  },

  formatDate (value, outwards) {
    if (this.$moment(value).isValid()) {
      if (outwards) {
        value = this.$moment(value).utc();
      }else{
        value = this.$moment.utc(value).local();
      }
    }
    return value.format('YYYY-MM-DD HH:mm:ss');
  },

  formatText (text) {
    const reg = {
      link: /\[([^\[]+)\]\(([^\)]+)\)(\^?)/gim, // [text](link) ^ can be added at end to set the target as 'blank'
      emphasis: /\*\*([^\*]+)\*\*/gim, // **emphasis**
      bold: /\*([^\*]+)\*/gim, // *bold*
      nowrap: /--([^\*]+)--/gim, // --nowrap--
      color: /##([^\*]+)##/gim, // ##primary text##
      br: /\n/gim,
    }
    return !!text ? text
      .replace(reg.link, (match, $1, $2, $3) => {
        var _target = $3 ? "blank" : ""; // check if '^' sign is present with link syntax
        // check if is app route or file
        const appURL = this.getAppRoot();
        const external = !_.startsWith($2, '/') && !_.startsWith($2, appURL);
        const file = /[^/\\&\?#]+\.\w{3,4}(?=([\?&#].*$|$))/.test($2);
        const link = "<a " + (external||file ? "data-popup "+(file ? "data-file" : "") : "") + "href='" + $2 +"'>" + $1 + "</a>";
        return (link);
      })
      .replace(reg.emphasis, "<em>$1</em>")
      .replace(reg.bold, "<b>$1</b>")
      .replace(reg.nowrap, "<span class='text-no-wrap'>$1</span>")
      .replace(reg.color, "<span class='primary--text'>$1</span>")
      .replace(reg.br, "<br/>") : '';
  },

  accentInsensitiveMatch (input, result) {
    const normalize = str => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    return normalize(result).includes(normalize(input));
  },

  translate (data, key='text', scope='') {
    if (_.isString(key)) key = [key]
    return _[_.isArray(data) ? 'map' : 'mapValues'](_.cloneDeep(data), item => {
      if (_.isString(item)) {
        item = this.$t(scope+item);
      }else{
        _.each(key, k => {
          if (k in item) item[k] = this.$t(scope+item[k]);
        });
      }
      return item;
    })
  },

  setLocale (selected=null) {
    const available = this.$i18n.availableLocales;
    const locale = selected || process.env.VUE_APP_I18N_LOCALE || this.getOptimalLocale(available, process.env.VUE_APP_I18N_FALLBACK_LOCALE);
    this.locale = locale;
    let lang = locale.indexOf('-')>=0 ? _.first(_.split(locale, '-')) : locale;
    this.$i18n.locale = locale;
    this.$vuetify.lang.current = lang;
    document.documentElement.setAttribute('lang', locale);
    // Dynamically find moment.js locale: try full locale first, fallback to lang
    const availableMomentLocales = this.$moment.locales();
    let momentLocale = availableMomentLocales.includes(locale) 
      ? locale 
      : (availableMomentLocales.includes(lang) ? lang : locale);
    
    // Set the locale - moment.locale() returns the locale that was actually set
    const actualLocale = this.$moment.locale(momentLocale);
    
    // If the requested locale wasn't set, try the fallback
    if (actualLocale !== momentLocale && momentLocale === locale && lang !== locale) {
      momentLocale = lang;
      const fallbackLocale = this.$moment.locale(momentLocale);
      if (fallbackLocale !== momentLocale) {
        console.warn(`Failed to set moment locale to "${locale}" or "${lang}". Available locales:`, availableMomentLocales, 'Using:', fallbackLocale);
        momentLocale = fallbackLocale;
      }
    }
    
    this.$numeral.locale(locale);
    this.$moment.updateLocale(momentLocale, this.$i18n.messages[locale].datetime);
    console.log('locale', locale, lang, 'momentLocale:', momentLocale, 'actual:', this.$moment.locale(), 'available:', availableMomentLocales);
  },

  getOptimalLocale(availableLocales, defaultLocale = 'en') {
    if (!Array.isArray(availableLocales) || availableLocales.length === 0) {
        throw new Error("Available locales must be a non-empty array");
    }

    // Get the user's preferred languages from the browser
    let userLocales = [Intl.DateTimeFormat().resolvedOptions().locale].concat(navigator.languages || [navigator.language || navigator.userLanguage]);
    console.log('userLocales', userLocales);
    
    // Normalize locales to lowercase for comparison
    const normalizedAvailable = availableLocales.map(loc => loc.toLowerCase());

    // Exact match
    // for (const locale of userLocales) {
    //     const lowerLocale = locale.toLowerCase();
    //     if (normalizedAvailable.includes(lowerLocale)) {
    //         return lowerLocale;
    //     }
    // }

    // Partial match (match language without region, e.g., "en-US" → "en")
    for (const locale of userLocales) {
        const langOnly = locale.split('-')[0].toLowerCase();
        const match = normalizedAvailable.find(avail => avail.startsWith(langOnly));
        if (match) {
            return match;
        }
    }

    // Return the default locale if no match is found
    return defaultLocale.toLowerCase();
  },

  async popup (url) {
    if (!url.includes('/file?url=')||this.isSupportedImageUrl(url)) {
      await Browser.open({ url });
    }
  },

  isSupportedImageUrl (url, formats=['.jpg', '.jpeg', '.png', '.webp']) {
    if (!url) return false;
    const supportedExts = formats;
    // const cleanUrl = url.split("?")[0].toLowerCase();
    return supportedExts.some(ext => url.endsWith(ext));
  },

  async loadFile (url) {
    // Download the PDF
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  },

  shareFile (filename, url) {
    this.loadFile(url).then((base64Data) => {
      Filesystem.writeFile({
        path: filename,
        data: base64Data,
        directory: Directory.Cache
      }).then(() => {
        return Filesystem.getUri({
          directory: Directory.Cache,
          path: filename
        });
      }).then((uriResult) => {
        return Share.share({
          title: filename,
          text: filename,
          url: uriResult.uri,
        });
      });
    });
  },

  // share (options) {
  //   Share.share(options);
  // },

  getAppRoot () {
    let url = process.env.VUE_APP_ROOT;
    if (url=='') {
      const { protocol, hostname, port } = window.location;
      url = `${protocol}//${hostname}${port ? ':' + port : ''}`;
    }
    return url;
  },

  translateNotation (key, dictionary=this.dictionary) {
    return key in dictionary ? dictionary[key] : key;
  },

  selectText (element, copy=false, message=null) {
    window.getSelection().selectAllChildren(element);
    if (copy) {
      const text = _.trim(element.innerText);
      const msg = message || this.$t('general.text_copied');
      Clipboard.write({ string: text }).then(() => {
        this.toggleToast(true, msg)
      });
    }
  },

  getContent (profile, contents, base=null) {
    const fleet = profile?.fleet || {};
    const { id_organization: oid=1, id: fid=null } = fleet;
    let content = base || 'default' in contents ? contents['default'] : 'default';

    const oid_fid = `${oid||1}:${fid}`;
    if (fid && oid_fid in contents) {
      content = contents[oid_fid]
    }else if (`${oid}` in contents) {
      content = contents[oid]
    }else if (this.$i18n && this.$i18n.locale && this.$i18n.locale in contents) {
      // Try to match with locale string before falling back to default
      content = contents[this.$i18n.locale]
    }
    return content;
  },

  maskToRegex (mask) {
    if (!mask || typeof mask !== 'string') {
      return null;
    }

    // Convert mask format to regex pattern
    // # = digit [0-9]
    // A = letter [A-Za-z]
    // X = alphanumeric [A-Za-z0-9]
    // The regex should match both:
    // 1. The full pattern with separators (dots, spaces, etc.)
    // 2. The raw data without separators
    
    // First, build pattern for raw data (only #, A, X)
    let rawPattern = '';
    // Then, build pattern with separators (making them optional)
    let fullPattern = '';
    
    for (let i = 0; i < mask.length; i++) {
      const char = mask[i];
      
      switch (char) {
        case '#':
          // Digit
          rawPattern += '[0-9]';
          fullPattern += '[0-9]';
          break;
        case 'A':
          // Letter (uppercase or lowercase)
          rawPattern += '[A-Za-z]';
          fullPattern += '[A-Za-z]';
          break;
        case 'X':
          // Alphanumeric
          rawPattern += '[A-Za-z0-9]';
          fullPattern += '[A-Za-z0-9]';
          break;
        case ' ':
          // Space - optional in full pattern, not in raw
          fullPattern += '\\s*';
          break;
        default:
          // Other characters (separators like dots, dashes, etc.) - optional in full pattern
          if (/[.*+?^${}()|[\]\\-]/.test(char)) {
            fullPattern += '(?:\\' + char + ')?';
          } else {
            fullPattern += '(?:' + char + ')?';
          }
          // Not included in raw pattern
          break;
      }
    }
    
    // Return regex that matches either full pattern with separators OR raw data
    // Use alternation: (fullPattern|rawPattern)
    return '^(' + fullPattern + '|' + rawPattern + ')$';
  },

  loadConfig (local=false) {
    const config = !!this.config && this.$moment().subtract(1, 'min').isBefore(this.$moment(this.config.timestamp)) ? this.config : null;
    const timestamp = Date.now();
    const url = (local ? `/config.json` : this.appURL)+'/config.json?t='+timestamp;
    return config || fetch(url, { cache: 'no-store' }).then(r => r.json()).then((json) => {
      return {
        ...json,
        timestamp
      };
    }).catch(error => {
      console.error(error);
    });
  },

  async loadHelpContent (local, file, key) {
    this.config = await this.loadConfig();
    console.log('config', this.config);
    const content = this.getContent(this.user?.profile||this.profile, this.config.help.contents);
    file = _.isNil(file) ? `/help/${content}.json` : file;
    key = _.isNil(key) ? new Date().valueOf() : key;
    const url = (local ? `/help/${content}.json` : this.appURL+file)+'?k='+key;
    console.log('help url', url);
    fetch(url, { cache: 'no-store' }).then(r => r.json()).then((json) => {
      const content = json[0];
      console.log(content);
      if (!local) {
        this.checkHelpCompatibility(content, (local ? 'local' : '')+file);
      }else{
        console.log('setHelpContent', file);
        this.storeHelpContent(content);
        this.help.version = { compatible: content.controller.compatible, file: (local ? 'local' : '')+file };
      }
    }).catch(error => {
      console.log('loadHelpContent', error);
      this.handleError(error, 'Failed to load '+file);
      this.loadHelpContent(true);
      // setTimeout(($) => {
      //   $.loadHelpContent(false);
      // }, 5000, this);
    });
  },

  checkHelpCompatibility (content, url) {
    const controller = content.controller;
    // Help version
    const [native, web] = _.split(controller.compatible, '/');
    const app = this.version;
    if (!_.has(app, 'native')||parseInt(app.native)>=parseInt(native)) {
      console.log('setHelpContent Compatible v', controller.compatible);
      this.storeHelpContent(content);
      this.help.version = { compatible: controller.compatible, url };
    }else{
      const best = _.find(controller.versions, v => {
        return parseInt(app.native)>=parseInt(_.split(v.compatible, '/')[0]);
      })
      if (_.isNil(best)) {
        console.log('loadHelpContent local...', null);
        this.loadHelpContent(true);
      }else{
        console.log('loadHelpContent Compatible found v', best.compatible);
        this.help.version = best;
        this.loadHelpContent(false, best.url)
      }
    }
  },

  storeHelpContent (content) {
    const help = this.helpContent;
    if (_.isNil(help)) {
      this.helpContent = Object.assign({}, content);
    }else{
      this.helpContent = Object.assign(_.cloneDeep(content), help);
      _.each(content, (v, k) => {
        if (_.isNil(v)) this.$delete(this.helpContent, k);
      })
    }
    if ('base' in content.controller) {
      this.loadHelpContent(false, content.controller.base);
    }
  },

  adfToString (adf, formatted=true) {
    if (!adf || !adf.content) return adf;

    let result = [];

    const walk = (node) => {
      if (!node) return;

      const type = node.type;

      // Text node
      if (type === 'text' && node.text) {
        result.push(node.text);
        if (formatted) result.push('\n'); // 1 line break after text
      }

      // Recurse into children
      if (Array.isArray(node.content)) {
        for (const child of node.content) {
          walk(child);
        }
      }

      // 2 line breaks for block-level elements (formatted mode)
      // if (formatted && ['paragraph', 'heading', 'blockquote'].includes(type)) {
      //   result.push('\n');
      // }
    }

    for (const item of adf.content || []) {
      walk(item);
    }

    let text = result.join('');

    if (formatted) {
      // Collapse excessive newlines (max 1)
      text = text.replace(/\n{2,}/g, '\n').trim();
    } else {
      // Return clean, single-line version
      text = text.replace(/\s+/g, ' ').trim();
    }

    return text;
  },

  textToADF (text) {
    const adf = {
      type: "doc",
      version: 1,
      content: []
    };

    const lines = text.split(/\r?\n/);
    let insideQuote = false;
    let quoteBuffer = [];

    function flushQuote() {
      if (quoteBuffer.length > 0) {
        adf.content.push({
          type: "blockquote",
          content: quoteBuffer.map(line => ({
            type: "paragraph",
            content: [{ type: "text", text: line }]
          }))
        });
        quoteBuffer = [];
      }
    }

    for (const rawLine of lines) {
      const line = rawLine.trim();

      if (!line) continue;

      // Start or end of {quote} block
      if (line === "{quote}") {
        if (insideQuote) {
          // closing
          flushQuote();
          insideQuote = false;
        } else {
          insideQuote = true;
        }
        continue;
      }

      if (insideQuote) {
        quoteBuffer.push(line);
        continue;
      }

      // Heading (h1. ... h6.)
      const headingMatch = line.match(/^(h[1-6])\.\s+(.*)$/);
      if (headingMatch) {
        const level = parseInt(headingMatch[1].substring(1), 10);
        adf.content.push({
          type: "heading",
          attrs: { level },
          content: [{ type: "text", text: headingMatch[2] }]
        });
        continue;
      }

      // Single-line blockquote (bq. ...)
      const blockquoteMatch = line.match(/^bq\.\s+(.*)$/);
      if (blockquoteMatch) {
        adf.content.push({
          type: "blockquote",
          content: [
            {
              type: "paragraph",
              content: [{ type: "text", text: blockquoteMatch[1] }]
            }
          ]
        });
        continue;
      }

      // Otherwise: paragraph with formatting
      const paragraph = { type: "paragraph", content: [] };
      let rest = line;

      // Bold *text*
      rest = rest.replace(/\*(.+?)\*/g, (_, txt) => {
        paragraph.content.push({
          type: "text",
          text: txt,
          marks: [{ type: "strong" }]
        });
        return "";
      });

      // Italic _text_
      rest = rest.replace(/_(.+?)_/g, (_, txt) => {
        paragraph.content.push({
          type: "text",
          text: txt,
          marks: [{ type: "em" }]
        });
        return "";
      });

      // Links [label|url]
      rest = rest.replace(/\[(.+?)\|(.+?)\]/g, (_, label, url) => {
        paragraph.content.push({
          type: "text",
          text: label,
          marks: [{ type: "link", attrs: { href: url } }]
        });
        return "";
      });

      // Remaining plain text
      if (rest.trim()) {
        paragraph.content.push({ type: "text", text: rest.trim() });
      }

      if (paragraph.content.length > 0) {
        adf.content.push(paragraph);
      }
    }

    // flush if ended inside {quote}
    if (insideQuote) flushQuote();

    return adf;
  },

  normalizeField (domain, value) {
    if (!domain || !value) return null;

    const messages = _.get(this.$i18n.messages[this.$i18n.locale], domain);
    if (!messages) return value;

    const normalize = (val) => {
      const normalized = val.trim().toLowerCase();
      for (const [k, v] of Object.entries(messages)) {
        if (k === "label") continue;
        if (String(v).toLowerCase() === normalized) {
          return k;
        }
      }
      const variations = [
        normalized.replace(/a$/, "o"),
        normalized.replace(/o$/, "a"),
      ];

      for (const variation of variations) {
        for (const [k, v] of Object.entries(messages)) {
          if (k === "label") continue;
          if (String(v).toLowerCase() === variation) {
            return k;
          }
        }
      }
      return normalized;
    };

    if (Array.isArray(value)) {
      return value.map(v => normalize(v));
    }
    return normalize(value);
  },

  mask (value, mask) {
    if (!value) return '';

    // Pick mask depending on input length if mask is array
    const maskPattern = Array.isArray(mask)
      ? mask.find(m => (value + '').length <= m.replace(/[^#]/g, '').length) || mask[mask.length - 1]
      : mask;

    const numbers = (value + '').replace(/\D+/g, '');
    let i = 0;
    let result = '';

    for (const c of maskPattern) {
      if (c === '#') {
        if (i < numbers.length) {
          result += numbers[i++];
        } else {
          break;
        }
      } else {
        if (i < numbers.length) {
          result += c;
        }
      }
    }

    return result;
  },

  getUserCity (user) {
    const address = user.profile.address;
    const city = !!address.city&&!!address.state ? address.city + '/' + address.state : null;
    return city;
  },

  locationEnabled () {
    return navigator.permissions.query({name:'geolocation'}).then(function(result) {
      return result.state === 'granted';
    });
  },

  handleError (error, msg, toast) {
    let timer = 7000;
    if (!this.isValid(msg)) {
      console.log('Network/Server Error', error);
      msg = this.$t('errors.network_error');
    }
    if (!this.isOnline) {
      msg = this.$t('errors.offline');
      timer = -1;
      console.log('Offline');
    }
    toast = this.isValid(toast) ? toast : false;
    if (toast||!this.isOnline) {
      this.toggleToast(
        true,
        msg,
        timer,
        false
      );
    }
    // if a `message` property exists or not
    const exception = !this.isOnline ? 'Offline' : _.isNil(msg) ? _.has(error, 'message') ? error.message : error : msg;
    this.$gtag.exception(_.isString(exception)||!_.has(exception, 'description') ? { description: exception } : exception);
  },

  trackEvent (category, action, label, value) {
    let event = {};
    if (this.isValid(category)) event['event_category'] = category;
    if (this.isValid(label)) event['event_label'] = label;
    if (this.isValid(value)) event['value'] = value;

    this.$gtag.event(action, event);
  },

  shouldUpdate (loader) {
    // console.log(loader.updatedAt, this.$moment(loader.updatedAt).add(...loader.lazyness));
    return (!loader.loading && loader.updatedAt==null) || this.$moment().isAfter(this.$moment(loader.updatedAt).add(...loader.lazyness));
  },

  isValid (data) {
    return typeof data != 'undefined' ? data != null : false;
  },
  slugify (text, file=false) {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    const s = file ? /[^\w\-.]+/g : /[^\w\-]+/g
  
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(s, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  },
  rawCPF (cpf) {
    return !!cpf ? cpf.replace(/^[.-]+|[.-]+$|[.-]+/g, "") : null;
  },
  rawData (data) {
    if (_.isNil(data)) console.log('profile', data);
    return !_.isNil(data) ? data.replace(/[^\w]/gi, '') : null;
  },

  getReferralURL (user) {
    return 'https://mobees.com.br/dirija?email-indicacao='+user.profile.email;
  },

  copyReferralURL (user=this.user) {
    console.log('installed', this.installed);
    
    if (this.installed||Capacitor.isNativePlatform()) {
      Clipboard.write({ string: this.getReferralURL(user) }).then(() => {
        this.onCopyReferralURL();
      });
    }else{
      navigator.clipboard.writeText(this.getReferralURL(user)).then(this.onCopyReferralURL, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  },
    
  onCopyReferralURL () {
    // this.dialog.buttons.ok.text = 'Copiado!'
    this.toggleToast(
      true,
      this.$t('referrals.cta.link_copied'),
      5000,
      false
    );
  },

  logout (cpf, token, ghost=null) {
    if (!!ghost) {
      this.getout();
      return;
    }
    this.$api
      .get(process.env.VUE_APP_ROOT_API+'/logout/'+cpf+'/'+token+'/?format=json')
      .then(response => {
        console.log('logout => ',response);
        if(response.data[0].retorno==200||response.data[0].retorno==401){
          console.log('logged out');
          OneSignal.logout();
          this.trackEvent('access', 'logout');
          this.getout();
        }else{
          this.toggleToast(
            true,
            this.$t('errors.logout_failed'),
            5000,
            false,
          );
        }
      })
      .catch(error => {
        // console.log('Network/Server Error', error);
        // this.toggleToast(
        //   true,
        //   'Erro na solicitação.',
        //   7000,
        //   false,
        //   'error'
        // );
        this.getout();
      });
  },

  getout () {
    this.delStorage('user').then(() => {
      localForage.removeItem('vuex', () => {
        window.location.href = '/login';
      });
    });
  },

  toggleToast (toggle, text, timeout=7000, button, color) {
    if(typeof button == 'undefined'||button===false) {
      button = {
        toggle: false,
        text: 'Ok',
        action: false
      };
    }
    if(typeof color == 'undefined'){
      color = 'var(--city-blue-50)';
    }
    this.$set(this, 'toast', {
      toggle,
      text,
      timeout,
      button,
      color
    });
  },

  normalize (data) {
    return this.isValid(data) && typeof data == 'string' ? data.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '';
  },

  insert (string, inside, index) {
    return [inside.slice(0, index), string, inside.slice(index, inside.length)].join('');
  },
  
  cancelToasts () {
    if (this.toast.toggle) {
      this.toast.toggle = false;
    }
  },

  setStorage (key, value, type='localStorage') {
    return Promise.resolve().then(() => {
      if (_.isObject(value)) value = JSON.stringify(value);
      window[type].setItem(key, value);
    });
  },
  getStorage (key, type='localStorage') {
    return Promise.resolve().then(async () => {
      let value = await window[type].getItem(key);
      if (_.startsWith(value, '{')||_.startsWith(value, '[')||value=='true'||value=='false') value = JSON.parse(value);
      return value;
    });
  },
  delStorage (key, type='localStorage') {
    return Promise.resolve().then(function () {
      window[type].removeItem(key);
    });
  },
}